import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { TipoNotificacaoEnum } from '../../../enums/tipo-notificacao-enum';
import { Util } from '../../../util/util';
import { LoteNotificacaoSms } from '../../lote-notificacao-sms';
import { NotificacaoSms } from '../../notificacao-sms';
import { NotificacoesSmsService } from '../../notificacoes-sms.service';
import { LoteNotificacaoSmsPK } from '../../pks/lote-notificacao-sms-pk';
import { NotificacaoSmsPK } from '../../pks/notificacao-sms-pk';

@Component({
  selector: 'app-notificacao-cancelamento-create',
  templateUrl: './notificacao-cancelamento-create.component.html',
  styleUrls: ['./notificacao-cancelamento-create.component.css']
})
export class NotificacaoCancelamentoCreateComponent implements OnInit {

  formularioInserirNotificacao: FormGroup;

  formularioNotificacaoCanelamento: FormGroup;

  listaNotificacoes: Array<NotificacaoSms> = [];

  displayedColumns: string[] = ['nomePessoaNotificacao', 'numTelefone'];

  data: any = [];

  dataSource: MatTableDataSource<any>;

  maxlengthMsgPaciente: number = 0;

  @ViewChild(MatSort) sort: MatSort | any;

  constructor(private notificacoesSmsService: NotificacoesSmsService,
    private router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog) {

    this.formularioNotificacaoCanelamento = this.formBuilder.group({
      dscMensagemNotificacao: [null, [Validators.required]],
      dscMotivoNotificacao: [null, [Validators.required]],
    });

    this.formularioInserirNotificacao = this.formBuilder.group({
      nomePessoaNotificacao: [null, [Validators.required, Validators.minLength(6)]],
      foneCelular: [null, [Validators.required]],
    });

    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit() {

    this.maxlengthMsgPaciente = Util.getTamanhaMaximoMensagemSmsSemTitulo();
  }

  save() {

    if (this.listaNotificacoes && this.listaNotificacoes.length > 0) {
      let loteNotificacaoSms: LoteNotificacaoSms = new LoteNotificacaoSms();
      loteNotificacaoSms.pk = new LoteNotificacaoSmsPK();
      loteNotificacaoSms.pk.tipoNotificacao = TipoNotificacaoEnum.CAN;

      loteNotificacaoSms.dscMensagemNotificacao = this.controlNotificacaoCanelamento.dscMensagemNotificacao.value;
      loteNotificacaoSms.dscMotivoNotificacao = this.controlNotificacaoCanelamento.dscMotivoNotificacao.value;
      loteNotificacaoSms.listaNotificacaoSms = this.listaNotificacoes;

      this.notificacoesSmsService
        .criar(loteNotificacaoSms).subscribe(data => {
          // console.log(data)

          this.gotoList();

        }, error => {
          console.log(error);
        });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Notificação não enviada. É necessário icluir pelo menos um telefone!'
        }
      });
    }
  }

  onSubmit() {
    this.save();
  }

  onSubmitNovaNotificacao() {

    let notificacaoSms: NotificacaoSms = new NotificacaoSms();
    notificacaoSms.pk = new NotificacaoSmsPK();
    notificacaoSms.pk.numTelefone = this.controlInserirNotificacao.foneCelular.value;
    notificacaoSms.nomePessoaNotificacao = this.controlInserirNotificacao.nomePessoaNotificacao.value;

    const notificacaoExistente: NotificacaoSms = this.listaNotificacoes.filter(notific => notific.pk.numTelefone === notificacaoSms.pk.numTelefone)[0];

    if (!notificacaoExistente) {
      this.listaNotificacoes.push(notificacaoSms);
      
      this.formularioInserirNotificacao.clearValidators();

      this.controlInserirNotificacao.foneCelular.setValue('');
      this.controlInserirNotificacao.nomePessoaNotificacao.setValue('');
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Telefone já incluído!'
        }
      });
    }

    this.configurarDataSource();
  }

  gotoList() {
    this.router.navigate(['/notificacoesCancelamento'], {
      state: {
        filtroLoteNotificacaoSms: history.state.filtroLoteNotificacaoSms,
      }
    });
  }

  configurarDataSource(): void {
    this.data = this.listaNotificacoes;
    this.dataSource = new MatTableDataSource<any>(this.data);
    this.dataSource.sort = this.sort;
  }

  get controlNotificacaoCanelamento() {
    return this.formularioNotificacaoCanelamento.controls;
  }

  get controlInserirNotificacao() {
    return this.formularioInserirNotificacao.controls;
  }

  mascaraFoneCustom(fone: string): [string, any] {

    return Util.mascaraFoneCustom(fone);

  }

}
